"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createQRCode = exports.deleteSchedule = exports.hideSchedule = exports.publishSchedule = exports.updateSchedule = exports.getScheduleDetail = exports.createSchedule = exports.getSchedules = void 0;
var core_1 = __importDefault(require("@/api/core"));
var getSchedules = function (params) {
    return core_1.default.get({
        url: '/schedules',
        params: params,
    });
};
exports.getSchedules = getSchedules;
var createSchedule = function (_a) {
    var generationNumber = _a.generationNumber, data = __rest(_a, ["generationNumber"]);
    return core_1.default.post({ url: '/schedules', data: data, params: { generationNumber: generationNumber } });
};
exports.createSchedule = createSchedule;
var getScheduleDetail = function (scheduleId) {
    return core_1.default.get({ url: "/schedules/".concat(scheduleId) });
};
exports.getScheduleDetail = getScheduleDetail;
var updateSchedule = function (scheduleId, data) { return core_1.default.put({ url: "/schedules/".concat(scheduleId), data: data }); };
exports.updateSchedule = updateSchedule;
var publishSchedule = function (scheduleId) {
    return core_1.default.post({ url: "/schedules/".concat(scheduleId, "/publish") });
};
exports.publishSchedule = publishSchedule;
var hideSchedule = function (scheduleId) {
    return core_1.default.post({ url: "/schedules/".concat(scheduleId, "/hide") });
};
exports.hideSchedule = hideSchedule;
var deleteSchedule = function (scheduleId) {
    return core_1.default.delete({ url: "/schedules/".concat(scheduleId) });
};
exports.deleteSchedule = deleteSchedule;
var createQRCode = function (_a) {
    var scheduleId = _a.scheduleId, eventId = _a.eventId, attendanceCheckStartedAt = _a.attendanceCheckStartedAt, attendanceCheckEndedAt = _a.attendanceCheckEndedAt, latenessCheckEndedAt = _a.latenessCheckEndedAt;
    return core_1.default.post({
        url: "/schedules/".concat(scheduleId, "/event/").concat(eventId, "/qr"),
        data: { attendanceCheckStartedAt: attendanceCheckStartedAt, attendanceCheckEndedAt: attendanceCheckEndedAt, latenessCheckEndedAt: latenessCheckEndedAt },
    });
};
exports.createQRCode = createQRCode;
